import { addEventListener, hide, show } from '../../../utilities/dom'
import './index.css'

export default class Index {
  constructor(title) {
    this.title = title
    this.body = this.body()
  }

  body(){
    let modal = document.querySelector('#bta-cart-to-reservation-modal')
    modal = modal ? modal : document.createElement('div')

    modal.id = 'bta-cart-to-reservation-modal'
    hide(modal)
    return modal
  }

  isShow(){
    return !this.body.classList.contains('bta-hide')
  }

  hide(){
    hide(this.body)
  }

  closeIcon(){
    const self = this,
          div = document.createElement('div')

    addEventListener([div], 'click', () => hide(self.body))

    div.id = 'bta-cart-to-reservation-modal-close'
    div.innerHTML = '&times;'
    return div
  }

  render(content) {
    this.body.innerHTML = `     
     <div id="bta-cart-to-reservation-modal-title"><h3>${this.title}</h3></div>    
     <div id="bta-cart-to-reservation-modal-content"></div>
    `
    this.body.querySelector('#bta-cart-to-reservation-modal-content').append(content)
    show(this.body)
    this.body.append(this.closeIcon())
    document.body.append(this.body)
  }
}
